var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.522 27.26v-2.942c5.63-.31 10.056-4.694 10.056-10.038a9.616 9.616 0 00-1.355-4.893l-.33-.537a.518.518 0 00-.693-.17l-1.385.849c-.211.141-.301.396-.15.622l.27.452c.663 1.132 1.024 2.404 1.024 3.677 0 3.987-3.252 7.239-7.407 7.55v-2.856c0-.368-.421-.594-.752-.396l-6.774 4.128a.436.436 0 000 .764L10.8 27.6c.3.226.722.028.722-.34z",
    fill: "#FFA700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 19.031c.211-.141.301-.396.15-.622l-.27-.453c-.663-1.159-1.024-2.375-1.024-3.676 0-3.987 3.282-7.24 7.406-7.578v2.856c0 .367.422.594.753.396l6.804-4.13a.436.436 0 000-.763L10.948.933c-.33-.198-.752.028-.752.396V4.24C4.596 4.552.14 8.936.14 14.281c0 1.696.482 3.393 1.355 4.891l.33.538c.151.226.452.31.693.17l1.385-.849z",
    fill: "#8E8E8E"
  })));
}
export default SvgRefreshIcon;